import K from "utilities/constants";
import { Divider, PageHeader, Tabs } from "antd";
import { pick } from "lodash";
import { ParseString, useQueryState } from "../../hooks/useQueryState";
import { ReportContainer } from "./reportContainer/reportContainer";
import LayoutCss from "../../layout/layout.module.scss";

const TabsConfig = {
  weekly: {
    key: "weekly",
    label: "Weekly",
    reportType: K.Clients.Reports.Type.Weekly,
  },
  monthly: {
    key: "monthly",
    label: "Monthly",
    reportType: K.Clients.Reports.Type.Monthly,
  },
};

export const ClientReporting = () => {
  const [tab, setTab] = useQueryState("tab", TabsConfig.weekly.key);

  const activeTab = TabsConfig[tab];

  const tabItems = Object.values(TabsConfig).map((t) =>
    pick(t, ["key", "label"]),
  );

  return (
    <>
      <PageHeader
        ghost={false}
        title="Client Reporting"
        footer={
          <>
            <Divider className={LayoutCss.appPageHeaderDivider} />
            <Tabs
              activeKey={activeTab.key}
              onChange={setTab}
              className={LayoutCss.appPageHeaderTabs}
              items={tabItems}
            />
          </>
        }
        className={LayoutCss.appPageHeader}
      />
      <ReportContainer type={activeTab.reportType} />
    </>
  );
};
